/**
 * Cipher Block Chaining Sample encryption scheme.
 *
 *
 * @beta
 */
export const CBCS = 'cbcs'
